import { useMemo } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Flame } from "lucide-react";

export function SimpleStreakDisplay({ streak = 0, showHistory = true }) {
  // Generate last 7 days directly from streak prop - no API call needed
  const last7Days = useMemo(() => {
    const today = new Date();
    const days = [];
    
    for (let i = 6; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(date.getDate() - i);
      const dayName = date.toLocaleDateString('en-US', { weekday: 'short' }).charAt(0);
      
      days.push({
        day: dayName,
        date: date.toISOString().split('T')[0],
        completed: i === 0 ? (streak > 0) : (6 - i < streak)
      });
    }
    
    return days;
  }, [streak]);

  return (
    <Card className="glass-card overflow-hidden" data-testid="simple-streak-display">
      <CardContent className="p-5">
        {/* Main Streak Display */}
        <div className="flex items-center justify-center gap-4 mb-6">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#a69373]/30 to-[#a69373]/10 flex items-center justify-center">
            <Flame className="w-8 h-8 text-[#a69373]" />
          </div>
          <div className="text-center">
            <p className="text-5xl font-heading text-[#a69373]">{streak}</p>
            <p className="text-[#a69373]/60 text-sm font-medium uppercase tracking-wider">Day Streak</p>
          </div>
        </div>

        {/* Last 7 Days */}
        {showHistory && last7Days.length > 0 && (
          <div>
            <p className="text-[#a69373]/50 text-xs text-center mb-3 uppercase tracking-wider">Last 7 Days</p>
            <div className="flex justify-center gap-2">
              {last7Days.map((day) => (
                <div key={day.date} className="flex flex-col items-center gap-1">
                  <div 
                    className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
                      day.completed 
                        ? "bg-[#a69373] shadow-lg shadow-[#a69373]/30" 
                        : "bg-white/10 border border-white/20"
                    }`}
                    data-testid={`streak-day-${day.day}`}
                  >
                    {day.completed && (
                      <Flame className="w-4 h-4 text-white" />
                    )}
                  </div>
                  <span className={`text-xs ${day.completed ? "text-[#a69373]" : "text-white/40"}`}>
                    {day.day}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default SimpleStreakDisplay;
